'use strict';

var PropTypes = require('prop-types');
var React = require("react");
var createReactClass = require('create-react-class');
var LocalizeMixin = require("../../localization/CommonLocalizationMixin");

var OrderFunnelFooter = createReactClass({
    displayName: 'OrderFunnelFooter',
    mixins: [LocalizeMixin],

    propTypes: {
        lang: PropTypes.string.isRequired,
        cntry: PropTypes.string.isRequired,
        linkCssClass: PropTypes.string
    },

    getDefaultProps: function getDefaultProps() {
        return {
            linkCssClass: ""
        };
    },

    render: function render() {
        var Config = require('../../lib/config').urls;
        var selectedLanguage = this.props.lang + '_' + this.props.cntry;
        var Divider = function Divider() {
            return React.createElement(
                'span',
                { className: 'divider' },
                ' | '
            );
        };
        var footerLinks = Config.nav.localized[selectedLanguage].footerLinks;
        return React.createElement(
            'footer',
            { className: 'order-funnel-footer', role: 'contentinfo' },
            this.getLocalizedText('footer_copyright'),
            React.createElement(Divider, null),
            this.getLocalizedText('footer_mailing_address'),
            React.createElement(Divider, null),
            React.createElement(
                'a',
                { className: this.props.linkCssClass, href: footerLinks.privacy_policy },
                this.getLocalizedText('footer_privacy')
            ),
            React.createElement(Divider, null),
            React.createElement(
                'a',
                { className: this.props.linkCssClass, id: 'terms_of_use', href: Config.terms[selectedLanguage] },
                this.getLocalizedText('footer_terms')
            ),
            React.createElement(Divider, null),
            React.createElement(
                'a',
                { className: this.props.linkCssClass, href: footerLinks.cookie_policy },
                this.getLocalizedText('footer_cookie')
            )
        );
    }
});

module.exports = OrderFunnelFooter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/OrderFunnelFooter/index.js
// module id = 788
// module chunks = 0